import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IUser, IUserChangePwd, IUserResetPwd } from "./users.interface";
import * as _ from 'lodash';
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class UserService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getUsers(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_AUTH)}/user${queryParams}`);
  }

  getUser(user: IUser | string): Observable<any> {
    let id = (typeof user == 'string') ? user : user._id;
    return this._http.get(`${apiURL(EnvConfig.API_AUTH)}/user/${id}`);
  }

  createUser(user: IUser): Observable<any> {
    return this._http._post(`${apiURL(EnvConfig.API_AUTH)}/register`, user);
  }

  updateUser(user: IUser): Observable<any> {
    let id = user._id;
    delete user._id;
    return this._http.patch(`${apiURL(EnvConfig.API_AUTH)}/user/${id}`, user);
  }

  changeUserPassword(user: IUser | string, credentials: IUserChangePwd): Observable<any> {
    let id = (typeof user == 'string') ? user : user._id;
    return this._http.post(`${apiURL(EnvConfig.API_AUTH)}/user/password/change/${id}`, credentials);
  }

  resetUserPassword(user: IUser | string, credentials: IUserResetPwd): Observable<any> {
    let id = (typeof user == 'string') ? user : user._id;
    return this._http.post(`${apiURL(EnvConfig.API_AUTH)}/user/password/reset/${id}`, credentials);
  }

  deleteUser(user: IUser | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof user == 'string') ? user : user._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_AUTH)}/user/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_AUTH)}/user/${id}/delete`);
  }

  restoreUser(user: IUser | string): Observable<void> {
    let id = (typeof user == 'string') ? user : user._id;
    return this._http.post(`${apiURL(EnvConfig.API_AUTH)}/user/${id}/restore`, null);
  }
}